import $ from 'jquery';

const ww = $(window).width();

module.exports = ww;
